import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

type Refresh = () => void

interface approveRefuseFraudItemReservationParams {
  hashItemReserve: string
  approveFraud: boolean
  refresh: Refresh
  notify: any
  setLoadingFraudItem: React.Dispatch<React.SetStateAction<boolean>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmFraud: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenFraudModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const approveRefuseFraudItemReservation  = async ({
  hashItemReserve,
  approveFraud,
  refresh,
  notify,
  setHashItemReserve,
  setLoadingFraudItem,
  setConfirmFraud,
  setOpenFraudModal
}: approveRefuseFraudItemReservationParams): Promise<void> => {
  try {
    setLoadingFraudItem(true)
    setOpenFraudModal && setOpenFraudModal(false)
    const response = await (approveFraud
      ? itemServices.approve_fraud_item(hashItemReserve)
      : itemServices.refuse_fraud_item(hashItemReserve)
    )
    if (response) {
      notify(approveFraud
        ? 'ra.notification.approve_fraud_item_reserve_success'
        : 'ra.notification.refuse_fraud_item_reserve_success',
        { type: 'success' }
      )
      setHashItemReserve('')
      setLoadingFraudItem(false)
      setConfirmFraud && setConfirmFraud(false)
      return
    }
    setHashItemReserve('')
    setConfirmFraud && setConfirmFraud(false)
    setLoadingFraudItem(false)
    notify(approveFraud
      ? 'ra.notification.approve_fraud_item_reserve_error'
      : 'ra.notification.refuse_fraud_item_reserve_error',
      { type: 'error' }
    )
  } catch (error: any) {
    notify(approveFraud
      ? 'ra.notification.approve_fraud_item_reserve_error'
      : 'ra.notification.refuse_fraud_item_reserve_error',
      { type: 'error' }
    )
    setOpenFraudModal && setOpenFraudModal(false)
    setHashItemReserve('')
    setLoadingFraudItem(false)
    setConfirmFraud && setConfirmFraud(false)
  } finally {
    customAwait([refresh])
  }
}
